import { IPartnersInfoResult } from '../interfaces/news';
import { ExtendedNewsOrg } from '../interfaces/organizations';
import { IGlobalState } from '../reducers';

export const getOrganizations = (state: IGlobalState): { [key: string]: ExtendedNewsOrg } =>
  state.organizations.list.data;
export const getPartners = (state: IGlobalState): IPartnersInfoResult => state.organizations.partners.data;
export const selectOrganizationMenuByAlias = (alias: string) => (state: IGlobalState) =>
  state.organizations.menu.data[alias];
